module.exports = __webpack_public_path__ + "img/ep8-1c.0eec88f6.png";